module.exports = __webpack_public_path__ + "images/logo-env_demo.svg?470ecee0b5fbdd83e2d8eb3bfbb16876";